import { render } from "./ConsultarPaquetes.vue?vue&type=template&id=69075d45"
import script from "./ConsultarPaquetes.vue?vue&type=script&lang=js"
export * from "./ConsultarPaquetes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__